import React from 'react'
import { Card } from '@myxplor/ui'

import LocalAsyncStore from '../local-async-store'
import List from '../ui/list'
import ActiveFilter, {
  Toggles as ActiveFilterToggles
} from '../ui/active-filter'
import { getRegHolder, urlName } from '../reg-holder'
import { RegHolderName } from '../layout'

import EnrolmentListItem from './list-item'
import EnrolmentSyncButtons from './views/sync-buttons'
import NoEnrolments from './views/empty'
import CareEnrolmentItem from './details'
import DragWrapper from '../drag-drop'
import ExpiryMessage from '../ui/expiry-message'
import './styles.css'

export const apiEndPoint = ({ record_type, id }) =>
  `/api/${record_type}/${id}/children`

export const activeChild = (child_record) =>
  child_record.status ? child_record.status !== 'inactive' : false

const objectFromSingleOrArray = (item) =>
  Array.isArray(item) ? objectFromArray(item) : objectFromArray([item])
const objectFromArray = (array = []) => {
  let out = {}
  array.forEach((id, i) => {
    out['__array' + i + id] = id
  })

  return out
}

export const filterShape = ({
  first_name,
  last_name,
  crn,
  dob,
  status,
  indigenous_status,
  jfa_eligible,
  gov_enrolment_ids = []
}) => ({
  name: [first_name, last_name].join(' '),
  last_name,
  crn,
  dob,
  indigenous: indigenous_status ? 'indigenous' : null,
  jfa_eligible: jfa_eligible ? 'jfa' : null,
  ...objectFromSingleOrArray(status),
  ...objectFromArray(gov_enrolment_ids)
})

const TopSection = ({ base_url, embedded, id, refresh_enrolments }) =>
  embedded ? (
    <div className='TopSection'>
      <ActiveFilterToggles>
        <EnrolmentSyncButtons
          regHolder={getRegHolder(base_url, id)}
          onComplete={() =>
            refresh_enrolments(
              apiEndPoint({
                record_type: urlName(getRegHolder(base_url, id)),
                id
              })
            )
          }
        />
      </ActiveFilterToggles>
    </div>
  ) : (
    <EnrolmentSyncButtons
      regHolder={getRegHolder(base_url, id)}
      onComplete={() =>
        refresh_enrolments(
          apiEndPoint({
            record_type: urlName(getRegHolder(base_url, id)),
            id
          })
        )
      }
    />
  )

export const CareEnrolments = ({
  enrolments,
  base_url,
  id,
  refresh_enrolments,
  embedded = false,
  record_type
}) => {
  return (
    <Card
      embedded={embedded}
      title={
        <ActiveFilterToggles>
          <RegHolderName />
        </ActiveFilterToggles>
      }
    >
      <ExpiryMessage service_id={id} />
      <TopSection
        base_url={base_url}
        embedded={embedded}
        id={id}
        refresh_enrolments={refresh_enrolments}
      />
      <DragWrapper>
        <ActiveFilter records={enrolments.data} filterOn={activeChild}>
          <List
            base_url={base_url}
            loading={enrolments.loading}
            listComponent={EnrolmentListItem}
            detailComponent={(props) => (
              <CareEnrolmentItem
                regHolderId={id}
                regHolderType={record_type}
                {...props}
              />
            )}
            emptyComponent={NoEnrolments}
            filterOn={filterShape}
          />
        </ActiveFilter>
      </DragWrapper>
    </Card>
  )
}

export default LocalAsyncStore('enrolments', CareEnrolments, apiEndPoint)



// WEBPACK FOOTER //
// ./src/care-enrolments/container.js